import React, { useState } from 'react';
import { Box, Flex, Table, Tbody, Td, Text, Th, Thead, Tr,} from "@chakra-ui/react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import Pagination from "components/ui/pagination/Pagination";

export default function FilteredDataTable({data}) {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
/* --------------------------------------------- Start Pagination  -----------------------------------------------*/
      const recordsPerPage = 10;
      const [currentPageActive, setCurrentPageActive] = useState(1);
      const prePage = (currentPage, setCurrentPage) => {
        if (currentPage > 1) {
          setCurrentPage(currentPage - 1);
        }
      };
    
      const nextPage = (currentPage, setCurrentPage, npage) => {
        if (currentPage < npage) {
          setCurrentPage(currentPage + 1);
        }
      };
    
      const calculateRecords = (data, currentPage, recordsPerPage) => {
        const firstIndex = (currentPage - 1) * recordsPerPage;
        const lastIndex = Math.min(currentPage * recordsPerPage, data?.length);
        return data?.slice(firstIndex, lastIndex);
      };
    
    // Calculate records for activeDiscounts
    const transfersFilteredData = calculateRecords(
        data,
        currentPageActive,
        recordsPerPage
      );
 /* --------------------------------------------- End Pagination  -----------------------------------------------*/
  return <>
    <>
    <Table>
        <Thead>
                <Tr>
                    <Th>{t("pages.transfers.reference")}</Th>
                    <Th>{t("pages.transfers.source")}</Th>
                    <Th>{t("pages.transfers.destination")}</Th>
                    <Th>{t("pages.transfers.type")}</Th>
                    <Th>{t("pages.transfers.status")}</Th>
                    <Th>{t("pages.transfers.business_date")}</Th>
                    <Th>{t("pages.transfers.receving_date")}</Th>
                    <Th>{t("pages.transfers.created")}</Th>
                </Tr>
        </Thead>
        <Tbody>
            {
            transfersFilteredData?.map((item, index) => (
                <Tr key={index} onClick={()=>navigate(`/inventory/transfer_details/${item.TransfersId}`)}>  
                    <Td > {item.TransfersRef} </Td>
                    <Td>{item.Source}</Td>
                    <Td>{item.Destination}</Td>
                    <Td>   </Td>
                    <Td> {item?.Status}  </Td>
                    <Td> {item?.CreateDate}  </Td>
                    <Td> {item?.ReceivingDueDate}  </Td>
                    <Td>  </Td>
                </Tr>
            ))
            }
        </Tbody>
    </Table>
    <Pagination
            currentPage={currentPageActive}
            setCurrentPage={setCurrentPageActive}
            npage={Math.ceil(data?.length / recordsPerPage)}
            prePage={() => prePage(currentPageActive, setCurrentPageActive)}
            nextPage={() =>
              nextPage(
                currentPageActive,
                setCurrentPageActive,
                Math.ceil(data?.length / recordsPerPage)
                )
              }
        />
    </>

  </>
};
